import {
  MaterialReactTable,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleFullScreenButton,
} from "material-react-table";

import DatagridTooltipProvider from "./datagridTooltipProvider.js";
import { useState } from "react";
import { useEffect } from "react";
import { useMemo, useRef } from "react";
import { Fragment } from "react";
import { connect } from "react-redux";

import SelectIcon from "@mui/icons-material/AddTask";
import CopyIcon from "@mui/icons-material/ContentCopy";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/FilterAltOff";
import ClearSortingIcon from "@mui/icons-material/MobiledataOff";
import FileDownloadIcon from "@mui/icons-material/NoteAdd";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";

import {
  mrtGetBottomToolbarSx,
  mrtGetContainerSx,
  mrtGetPaperSx,
  mrtGetTableWrapperSx,
  mrtGetTopToolbarFlexSx,
} from "../../utils/helpers";
import { isBefore } from "date-fns";
import { useSnackbar } from "notistack";

import constants from "../../assets/constants";
import * as OmniDataAPI from "../../data/omniDataAPI";
import { createNewReport } from "../../data/omniDataModel";
import * as AdminSessionActions from "../../state/redux/adminSession";
import { capitalizeAllWords, formatIsoDateString } from "../../utils/helpers";
import {
  createOmniPaginationObject,
  getOnboardingLabelFromAssessmentType,
} from "../../utils/helpers";
import { deepCopyObject, getReportOnlyFields } from "../../utils/helpers";
import AlertDialog from "../dialogs/alertDialog";
import TextInputDialog from "../dialogs/textInputDialog";
import OmniGridButton from "../ui/omniGridButton";

const getInviteStatus = row => {
  if (
    isBefore(new Date(row.omniData.expiresAt), new Date()) &&
    !row.omniData.userData.filledDatetime
  ) {
    return "Expired";
  } else if (row.omniData.invitationStatus === "created") {
    return "Invite Open";
  } else if (row.omniData.invitationStatus === "complete") {
    return "Onboard";
  } else {
    return row.omniData.invitationStatus;
  }
};

const calculateColumns = inviteSurveyType => {
  if (inviteSurveyType === constants.inviteSurveyType.shared) {
    return [
      {
        accessorKey: "omniData._onboarded_count",
        enableColumnFilterModes: false,
        header: "Used",
        size: 100,
        enableColumnFilter: false,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "omniData.onboardingAssessmentType",
        enableColumnFilterModes: false,
        header: "Onboarding",
        enableSorting: false,
        size: 155,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },

        filterFn: "equals",
        filterSelectOptions: [
          { text: "AR-1001", value: constants.assessmentIDs.ar1001Prescreen },
          { text: "PHQ-9", value: constants.assessmentIDs.phq9 },
          { text: "OH: Independent", value: constants.assessmentIDs.independentFunction },
          { text: "OH: History", value: constants.assessmentIDs.omniHealthHistory },
          { text: "CF: Weight", value: constants.assessmentIDs.careFirstWeight },
          { text: "EOS: 5 Pillars", value: constants.assessmentIDs.eos5Pillars },
          {
            text: "EOS: Business Information",
            value: constants.assessmentIDs.eosBusinessInformation,
          },
          { text: "EOS: Onboarding", value: constants.assessmentIDs.eosOnboarding },
          { text: "OH: MS Onboard", value: constants.assessmentIDs.omniMSOnboard },
          { text: "HW:  Onboard", value: constants.assessmentIDs.omniMSOnboard },
        ],
        filterVariant: "select",

        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={theme => ({
              backgroundColor: theme.palette.warning.main,
              borderRadius: "0.25rem",
              color: "#fff",
              maxWidth: "16ch",
              minWidth: "16ch",
              p: "0.25rem",
            })}
          >{`${getOnboardingLabelFromAssessmentType(cell.getValue())}`}</Box>
        ),
      },

      {
        accessorKey: "omniData.target",
        enableColumnFilterModes: false,
        header: "Campaign",
        enableSorting: false,
        grow: true,
      },
      {
        accessorFn: row => `${row.omniData.userData.givenName} ${row.omniData.userData.familyName}`, //accessorFn used to join multiple data into a single cell
        id: "owner", //id is still required when using accessorFn instead of accessorKey
        enableColumnFilterModes: false,
        header: "Owner",
        size: 125,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "row.omniData.userData.givenName",
        //accessorFn used to join multiple data into a single cell
        id: "ownerGiven", //id is still required when using accessorFn instead of accessorKey
        enableColumnFilterModes: false,
        header: "Owner First",
        size: 90,
        enableColumnFilter: true,
      },
      {
        accessorKey: "row.omniData.userData.familyName",
        //accessorFn used to join multiple data into a single cell
        id: "ownerFamily", //id is still required when using accessorFn instead of accessorKey
        enableColumnFilterModes: false,
        header: "Owner Last",
        size: 90,
        enableColumnFilter: true,
      },
      {
        accessorFn: row => `${getInviteStatus(row)}`, //accessorFn used to join multiple data into a single cell
        id: "omniData.invitationStatus",
        enableColumnFilterModes: false,
        header: "Status",
        size: 70,
      },
      {
        accessorKey: "omniData.userType",

        enableColumnFilterModes: false,
        header: "User Type",
        size: 70,
      },
      {
        accessorKey: "omniAudit.createdDate",
        enableColumnFilterModes: false,
        header: "Created",
        size: 125,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        enableColumnFilter: false,
        //custom conditional format and styling
        Cell: ({ cell }) => <Box component="span">{`${formatIsoDateString(cell.getValue())}`}</Box>,
      },
      {
        accessorKey: "omniData.inviteKey",
        enableColumnFilterModes: false,
        header: "Key",
        size: 250,
      },
    ];
  }

  if (inviteSurveyType === constants.inviteSurveyType.auto) {
    return [
      {
        accessorKey: "_id",
        enableColumnFilterModes: false,
        header: "ID",
        size: 150,
      },
      {
        accessorKey: "omniData._onboarded_count",
        enableColumnFilterModes: false,
        header: "Used",
        size: 100,
        enableColumnFilter: false,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "omniData.invitationStatus",
        enableColumnFilterModes: false,
        header: "Status",
        size: 135,
        enableSorting: false,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        filterFn: "equals",
        filterSelectOptions: [
          { text: "Open", value: "created" },
          { text: "Used", value: "complete" },
          { text: "Unsubscribed", value: "unsubscribed" },
        ],
        filterVariant: "select",

        //custom conditional format and styling
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={theme => ({
              backgroundColor:
                cell.getValue() === "created"
                  ? theme.palette.success.main
                  : cell.getValue() === "complete"
                    ? theme.palette.info.main
                    : theme.palette.error.main,
              borderRadius: "0.25rem",
              color: "#fff",
              maxWidth: "14ch",
              minWidth: "14ch",
              p: "0.25rem",
            })}
          >
            {cell.getValue() === "created"
              ? "Open"
              : cell.getValue() === "complete"
                ? "Used"
                : capitalizeAllWords(cell.getValue())}
          </Box>
        ),
      },
      {
        accessorKey: "omniData.userData.familyName",
        enableColumnFilterModes: false,
        header: "Last Name",
        grow: true,
        enableSorting: false,
      },
      {
        accessorKey: "omniData.userData.givenName",
        enableColumnFilterModes: false,
        header: "First Name",
        size: 150,
        grow: true,
        enableSorting: false,
      },
      {
        accessorKey: "omniAudit.createdDate",
        enableColumnFilterModes: false,
        header: "Created",
        size: 125,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        enableColumnFilter: false,
        //custom conditional format and styling
        Cell: ({ cell }) => <Box component="span">{`${formatIsoDateString(cell.getValue())}`}</Box>,
      },
      {
        accessorKey: "omniData.inviteKey",
        enableColumnFilterModes: false,
        header: "Key",
        size: 250,
      },
    ];
  }

  if (inviteSurveyType === constants.inviteSurveyType.personal) {
    return [
      {
        accessorKey: "_id",
        enableColumnFilterModes: false,
        header: "ID",
        size: 150,
      },
      {
        accessorKey: "omniData.invitationStatus",
        enableColumnFilterModes: false,
        header: "Status",
        size: 135,
        enableSorting: false,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },

        filterFn: "equals",
        filterSelectOptions: [
          { text: "Open", value: "created" },
          { text: "Used", value: "complete" },
          { text: "Unsubscribed", value: "unsubscribed" },
        ],
        filterVariant: "select",

        //custom conditional format and styling
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={theme => ({
              backgroundColor:
                cell.getValue() === "created"
                  ? theme.palette.success.main
                  : cell.getValue() === "complete"
                    ? theme.palette.info.main
                    : theme.palette.error.main,
              borderRadius: "0.25rem",
              color: "#fff",
              maxWidth: "14ch",
              minWidth: "14ch",
              p: "0.25rem",
            })}
          >
            {cell.getValue() === "created"
              ? "Open"
              : cell.getValue() === "complete"
                ? "Used"
                : capitalizeAllWords(cell.getValue())}
          </Box>
        ),
      },
      {
        accessorKey: "omniData.onboardingAssessmentType",
        enableColumnFilterModes: false,
        header: "Onboarding",
        enableSorting: false,
        size: 155,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },

        filterFn: "equals",
        filterSelectOptions: [
          { text: "AR-1001", value: "ar1001Prescreen" },
          { text: "PHQ-9", value: "phq9" },
          { text: "OH: Independent", value: "IndependentFunction" },
          { text: "OH: History", value: "omniHealthHistory" },
          { text: "CF: Weight", value: "careFirstWeight" },
          { text: "PCR: Hair Loss", value: "pcrHairLoss" },
        ],
        filterVariant: "select",

        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={theme => ({
              backgroundColor: theme.palette.warning.main,
              borderRadius: "0.25rem",
              color: "#fff",
              maxWidth: "16ch",
              minWidth: "16ch",
              p: "0.25rem",
            })}
          >{`${getOnboardingLabelFromAssessmentType(cell.getValue())}`}</Box>
        ),
      },

      {
        accessorKey: "omniData.target",
        enableColumnFilterModes: false,
        header: "Campaign",
        grow: true,
        enableSorting: false,
      },
      {
        accessorKey: "omniData.userData.familyName",
        enableColumnFilterModes: false,
        header: "Last Name",
        size: 100,
        enableSorting: false,
      },
      {
        accessorKey: "omniData.userData.givenName",
        enableColumnFilterModes: false,
        header: "First Name",
        size: 100,
        enableSorting: false,
      },
      {
        accessorKey: "omniAudit.createdDate",
        enableColumnFilterModes: false,
        header: "Created",
        size: 125,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        enableColumnFilter: false,
        //custom conditional format and styling
        Cell: ({ cell }) => <Box component="span">{`${formatIsoDateString(cell.getValue())}`}</Box>,
      },
      {
        accessorKey: "omniData.inviteKey",
        enableColumnFilterModes: false,
        header: "Key",
        size: 250,
      },
    ];
  }

  if (inviteSurveyType === constants.inviteSurveyType.comms) {
    return [
      {
        accessorKey: "omniData.target",
        enableColumnFilterModes: false,
        header: "Campaign",
        grow: true,
        enableSorting: false,
      },
      {
        accessorKey: "omniData.userData.familyName",
        enableColumnFilterModes: false,
        header: "Last Name",
        size: 100,
        enableSorting: false,
      },
      {
        accessorKey: "omniData.userData.givenName",
        enableColumnFilterModes: false,
        header: "First Name",
        size: 100,
        enableSorting: false,
      },
      {
        accessorKey: "omniData.invitationStatus",
        enableColumnFilterModes: false,
        header: "Status",
        size: 135,
        enableSorting: false,
        enableColumnFilter: false,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },

        filterFn: "equals",
        filterSelectOptions: [
          { text: "Open", value: "created" },
          { text: "Used", value: "complete" },
          { text: "Unsubscribed", value: "unsubscribed" },
        ],
        filterVariant: "select",

        //custom conditional format and styling
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={theme => ({
              backgroundColor:
                cell.getValue() === "created"
                  ? theme.palette.success.main
                  : cell.getValue() === "complete"
                    ? theme.palette.info.main
                    : theme.palette.error.main,
              borderRadius: "0.25rem",
              color: "#fff",
              maxWidth: "14ch",
              minWidth: "14ch",
              p: "0.25rem",
            })}
          >
            {cell.getValue() === "created"
              ? "Open"
              : cell.getValue() === "complete"
                ? "Used"
                : capitalizeAllWords(cell.getValue())}
          </Box>
        ),
      },
      {
        accessorKey: "omniAudit.createdDate",
        enableColumnFilterModes: false,
        header: "Created",
        size: 125,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        enableColumnFilter: false,
        //custom conditional format and styling
        Cell: ({ cell }) => <Box component="span">{`${formatIsoDateString(cell.getValue())}`}</Box>,
      },
      {
        accessorKey: "omniData.inviteKey",
        enableColumnFilterModes: false,
        header: "Key",
        size: 250,
      },
    ];
  }

  if (inviteSurveyType === constants.inviteSurveyType.all) {
    return [
      {
        accessorKey: "omniData._onboarded_count",
        enableColumnFilterModes: false,
        header: "Used",
        size: 100,
        enableColumnFilter: false,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "omniData.invitationStatus",
        enableColumnFilterModes: false,
        header: "Status",
        size: 135,
        enableSorting: false,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        filterFn: "equals",
        filterSelectOptions: [
          { text: "Open", value: "created" },
          { text: "Used", value: "complete" },
          { text: "Unsubscribed", value: "unsubscribed" },
        ],
        filterVariant: "select",

        //custom conditional format and styling
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={theme => ({
              backgroundColor:
                cell.getValue() === "created"
                  ? theme.palette.success.main
                  : cell.getValue() === "complete"
                    ? theme.palette.info.main
                    : theme.palette.error.main,
              borderRadius: "0.25rem",
              color: "#fff",
              maxWidth: "14ch",
              minWidth: "14ch",
              p: "0.25rem",
            })}
          >
            {cell.getValue() === "created"
              ? "Open"
              : cell.getValue() === "complete"
                ? "Used"
                : capitalizeAllWords(cell.getValue())}
          </Box>
        ),
      },
      {
        accessorKey: "omniData.userType",

        enableColumnFilterModes: false,
        header: "Type",
        size: 135,
        enableSorting: false,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },

        filterFn: "equals",
        filterSelectOptions: [
          { text: "Partner", value: "partner" },
          { text: "Provider", value: "provider" },
          { text: "Admin", value: "administrator" },
        ],
        filterVariant: "select",

        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={theme => ({
              backgroundColor:
                cell.getValue() === "partner"
                  ? theme.palette.info.main
                  : theme.palette.warning.main,
              borderRadius: "0.25rem",
              color: "#fff",
              maxWidth: "14ch",
              minWidth: "14ch",
              p: "0.25rem",
            })}
          >
            {capitalizeAllWords(cell.getValue())}
          </Box>
        ),
      },
      {
        accessorKey: "omniData.target",
        enableColumnFilterModes: false,
        header: "Campaign",
        grow: true,
        enableSorting: false,
      },
      {
        accessorKey: "omniData.userData.familyName",
        enableColumnFilterModes: false,
        header: "Last Name",
        size: 100,
        enableSorting: false,
      },
      {
        accessorKey: "omniData.userData.givenName",
        enableColumnFilterModes: false,
        header: "First Name",
        size: 100,
        enableSorting: false,
      },
      {
        accessorKey: "omniAudit.createdDate",
        enableColumnFilterModes: false,
        header: "Created",
        size: 125,

        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        enableColumnFilter: false,
        //custom conditional format and styling
        Cell: ({ cell }) => <Box component="span">{`${formatIsoDateString(cell.getValue())}`}</Box>,
      },
      {
        accessorKey: "omniData.inviteKey",
        enableColumnFilterModes: false,
        header: "Key",
        size: 250,
      },
    ];
  }
  //default case
  return [
    {
      accessorKey: "_id",
      enableColumnFilterModes: false,
      header: "ID",
      size: 150,
    },
    {
      accessorKey: "omniData.expirationTime",
      enableColumnFilterModes: false,
      header: "Expires",
      size: 150,
    },
    {
      accessorKey: "omniData.inviteType",
      enableColumnFilterModes: false,
      header: "Type",
      size: 150,
    },
    {
      accessorKey: "omniData.target",
      enableColumnFilterModes: false,
      header: "Campaign",
      grow: true,
      enableSorting: false,
    },
    {
      accessorKey: "omniData.invitationStatus",
      enableColumnFilterModes: false,
      header: "Status",
      size: 135,
      enableSorting: false,

      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      filterFn: "equals",
      filterSelectOptions: [
        { text: "Open", value: "created" },
        { text: "Used", value: "complete" },
        { text: "Unsubscribed", value: "unsubscribed" },
      ],
      filterVariant: "select",

      //custom conditional format and styling
      Cell: ({ cell }) => (
        <Box
          component="span"
          sx={theme => ({
            backgroundColor:
              cell.getValue() === "created"
                ? theme.palette.success.main
                : cell.getValue() === "complete"
                  ? theme.palette.info.main
                  : theme.palette.error.main,
            borderRadius: "0.25rem",
            color: "#fff",
            maxWidth: "14ch",
            minWidth: "14ch",
            p: "0.25rem",
          })}
        >
          {cell.getValue() === "created"
            ? "Open"
            : cell.getValue() === "complete"
              ? "Used"
              : capitalizeAllWords(cell.getValue())}
        </Box>
      ),
    },
    {
      accessorKey: "omniData.sentDatetime",
      enableColumnFilterModes: false,
      header: "Create Date",
      size: 150,
    },
    {
      accessorKey: "omniData.filledDatetime",
      enableColumnFilterModes: false,
      header: "Used Date",
      size: 150,
    },
    {
      accessorKey: "omniData.userData.givenName",
      enableColumnFilterModes: false,
      header: "First Name",
      size: 100,
      enableSorting: false,
    },
    {
      accessorKey: "omniData.userData.familyName",
      enableColumnFilterModes: false,
      header: "Last Name",
      size: 100,
      enableSorting: false,
    },
    {
      accessorKey: "omniData.userType",
      enableColumnFilterModes: false,
      header: "User Type",
      size: 150,
    },
    {
      accessorKey: "omniData._onboarded_count",
      enableColumnFilterModes: false,
      header: "Used",
      size: 100,
    },
    {
      accessorKey: "omniAudit.createdDate",
      enableColumnFilterModes: false,
      header: "Created",
      size: 125,

      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableColumnFilter: false,
      //custom conditional format and styling
      Cell: ({ cell }) => <Box component="span">{`${formatIsoDateString(cell.getValue())}`}</Box>,
    },
    {
      accessorKey: "omniData.inviteKey",
      enableColumnFilterModes: false,
      header: "Key",
      size: 250,
    },
  ];
};

const getInitialState = inviteSurveyType => {
  if (inviteSurveyType === constants.inviteSurveyType.shared) {
    return {
      density: "compact",
      columnVisibility: {
        _id: false,

        "omniData.inviteKey": false,
        "omniData.userType": false,
        ownerGiven: false,
        ownerFamily: false,
        "omniData.invitationStatus": false,
      },
    };
  } else if (inviteSurveyType === constants.inviteSurveyType.auto) {
    return {
      density: "compact",
      columnVisibility: {
        _id: false,
        "omniData.inviteKey": false,
        "omniAudit.createdDate": false,
      },
    };
  } else if (inviteSurveyType === constants.inviteSurveyType.personal) {
    return {
      density: "compact",
      columnVisibility: {
        _id: false,
        "omniData.inviteKey": false,
        "omniAudit.createdDate": false,
        "omniData.userData.givenName": false,
      },
    };
  } else if (inviteSurveyType === constants.inviteSurveyType.comms) {
    return {
      density: "compact",
      columnVisibility: {
        _id: false,
        "omniData.inviteKey": false,
        "omniData.userData.givenName": false,
        "omniAudit.createdDate": false,
      },
    };
  } else if (inviteSurveyType === constants.inviteSurveyType.all) {
    return {
      density: "compact",
      columnVisibility: {
        _id: false,
        "omniData.inviteKey": false,
        "omniData.userData.givenName": false,
        "omniAudit.createdDate": false,
      },
    };
  }
  return {
    density: "compact",
    columnVisibility: {
      _id: false,
      "omniData.inviteKey": false,
    },
  };
};

export const SurveyInvites = props => {
  const {
    inviteODMs,
    inviteSurveyType = constants.inviteSurveyType.shared,
    onEditInvite = null,
    onSelectInvite = null,
    onRequestNewPage = null,
    isLoading = false,
    invitePagination = createOmniPaginationObject,
  } = props;

  const { enqueueSnackbar } = useSnackbar();

  const theme = useTheme();
  const mobileLayout = useMediaQuery(theme.breakpoints.down("sm"));
  const tableContainerRef = useRef(null); //we can get access to the underlying TableContainer element and react to its scroll events

  const columns = useMemo(() => calculateColumns(inviteSurveyType), [inviteSurveyType]);
  const initialState = useMemo(() => getInitialState(inviteSurveyType), [inviteSurveyType]);

  const [showReportNameInput, setShowReportNameInput] = useState(null);

  const [showConfirm, setShowConfirm] = useState(false);

  const [rowCount, setRowCount] = useState(0);

  useEffect(() => {
    if (invitePagination != null) {
      setPagination({
        pageIndex: invitePagination.pageIndex - 1,
        pageSize: invitePagination.pageSize,
      });
      setRowCount(invitePagination.totalItems);
    }
  }, [invitePagination]);

  const [sorting, setSorting] = useState([]);

  const [columnFilters, setColumnFilters] = useState([]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  useEffect(() => {
    let newQuery = {};
    columnFilters.forEach((element, index) => {
      newQuery[element.id] = {
        "#regex": `${element.value}`,
        "#options": "i",
      };
    });

    let newSorting = {};
    sorting.forEach(element => {
      newSorting[element.id] = element.desc ? -1 : 1;
    });

    if (
      invitePagination &&
      (pagination.pageIndex + 1 !== invitePagination.pageIndex ||
        pagination.pageSize !== invitePagination.pageSize ||
        JSON.stringify(pagination.query) !== JSON.stringify(columnFilters))
    ) {
      let newPage = createOmniPaginationObject(invitePagination);
      newPage.pageIndex = pagination.pageIndex + 1;
      newPage.pageSize = pagination.pageSize;

      if (inviteSurveyType === constants.inviteSurveyType.comms) {
        //for comms we requre that we only send to
        //single invites AND open Invitations
        newQuery["omniData.inviteType"] = constants.inviteType.single;
        //move this out?
        newQuery["omniData.invitationStatus"] = "created";
      }
      newPage.query = newQuery;
      newPage.sort = newSorting;

      onRequestNewPage(newPage);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnFilters, inviteSurveyType, sorting, pagination.pageIndex, pagination.pageSize]);

  const [deleteAllPages, setDeleteAllPages] = useState(false);

  useEffect(() => {
    if (deleteAllPages) {
      enqueueSnackbar(`Deleting Records (~10 sec)`, {
        variant: "info",
      });

      OmniDataAPI.deleteBulkInvites(invitePagination.query).then(results => {
        setTimeout(() => {
          enqueueSnackbar(`Delete Complete`, {
            variant: "success",
          });
          let newPad = deepCopyObject(invitePagination);
          newPad.invalidateCache = true;
          onRequestNewPage(newPad);
        }, 10000);
      });
      setDeleteAllPages(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteAllPages, enqueueSnackbar]);

  if (inviteODMs == null) {
    return <Fragment></Fragment>;
  }

  return (
    <DatagridTooltipProvider>
      <Box sx={mrtGetTableWrapperSx(298, !inviteODMs?.length)}>
      <MaterialReactTable
      disabled={true}
      layoutMode="grid"
      columns={columns}
      data={inviteODMs}
      initialState={initialState}
      defaultColumn={{
        minSize: 20, //allow columns to get smaller than default
        maxSize: 9001, //allow columns to get larger than default
        size: 100, //make columns wider by default
        grow: false,
      }}
      // onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
      state={{
        columnFilters,
        isLoading,
        pagination,
        sorting,
      }}
      //pagination
      manualPagination={true}
      onPaginationChange={setPagination}
      manualSorting
      manualFiltering
      onSortingChange={setSorting}
      //header
      onColumnFiltersChange={setColumnFilters}
      enableColumnActions={false}
      enableStickyHeader={true}
      enableColumnFilterModes={true}
      filterFns={{
        customFilterFn: (row, id, filterValue) => {
          return row.getValue(id) === filterValue;
        },
      }}
      muiTableHeadCellFilterTextFieldProps={{
        sx: {
          "& .MuiInputBase-input": { padding: "6px" },
          "& .MuiInputBase-root": { paddingRight: "0px" },
          "& .MuiSelect-iconOutlined": { marginRight: "0.75rem" },
          "& .MuiSelect-outlined": { paddingRight: "0px" },

          width: "100%",
        },
        variant: "outlined",
      }}
      //rows
      enableRowActions={
        inviteSurveyType !== constants.inviteSurveyType.comms &&
        inviteSurveyType !== constants.inviteSurveyType.auto &&
        inviteSurveyType !== constants.inviteSurveyType.all
      }
      // enableRowSelection={inviteSurveyType === constants.inviteSurveyType.personal}
      getRowId={originalRow => originalRow._id}
      rowCount={rowCount}
      //rendering Props below
      positionToolbarAlertBanner="bottom"
      renderTopToolbarCustomActions={() => <Box sx={{ minHeight: "40px" }} />}
      muiTopToolbarProps={{
        sx: {
          ...mrtGetTopToolbarFlexSx(),
          backgroundColor: theme.palette.commonground.main,
          color: theme.palette.secondary.main,
        },
      }}
      muiBottomToolbarProps={{
        sx: mrtGetBottomToolbarSx(theme),
      }}
      muiTablePaperProps={{
        sx: mrtGetPaperSx(),
      }}
      muiTableContainerProps={{
        ref: tableContainerRef, //get access to the table container element
        sx: mrtGetContainerSx(theme, mobileLayout),
      }}
      muiTableProps={{
        sx: {
          backgroundColor: theme.palette.commonground.main,
          color: theme.palette.commonground.main,
        },
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: alpha(theme.palette.commonground.contrastText, 0.25),
          color: theme.palette.commonground.contrastText,
          justifyContent: "start",
        },
      }}
      renderRowActions={({ row }) => (
        <Box
          sx={{
            display: "flex",
            flexWrap: "nowrap",
            gap: "2px",
            padding: 0,
          }}
        >
          {!onSelectInvite && (
            <OmniGridButton
              key="Copy"
              onClick={() => {
                let onboardUrl = `${window.location.origin}/onboarding?inviteKey=${row.original.omniData.inviteKey}`;
                navigator.clipboard.writeText(onboardUrl);

                enqueueSnackbar("Invite URL Copied to Clipboard", {
                  variant: "success",
                });
              }}
              icon={<CopyIcon fontSize="small" />}
            />
          )}

          {onSelectInvite && (
            <OmniGridButton
              key="Edit"
              onClick={() => {
                onSelectInvite(row.original);
                setColumnFilters([]);
              }}
              icon={<SelectIcon fontSize="small" />}
            />
          )}

          {onEditInvite && (
            <OmniGridButton
              key="Edit"
              onClick={() => {
                onEditInvite(row.original);
              }}
              icon={<EditIcon fontSize="small" />}
            />
          )}
        </Box>
      )}
      renderToolbarInternalActions={({ table }) => (
        <Box>
          {inviteSurveyType === constants.inviteSurveyType.personal &&
            Object.keys(invitePagination.query).length > 0 &&
            invitePagination.totalItems > 0 && (
              <Tooltip title="Delete Filtered invitations" arrow>
                <IconButton
                  sx={{ color: theme.palette.secondary.main }}
                  onClick={() => {
                    setShowConfirm(true);
                  }}
                >
                  <DeleteSweepIcon />
                </IconButton>
              </Tooltip>
            )}

          {sorting.length > 0 && (
            <Tooltip title="Clear All Sorting" arrow>
              <IconButton
                sx={{ color: theme.palette.secondary.main }}
                onClick={() => {
                  setSorting([]);
                }}
              >
                <ClearSortingIcon />
              </IconButton>
            </Tooltip>
          )}

          {columnFilters.length > 0 && (
            <Tooltip title="Clear All Filters" arrow>
              <IconButton
                sx={{ color: theme.palette.secondary.main }}
                onClick={() => {
                  setColumnFilters([]);
                }}
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          )}

          {/* eslint-disable react/jsx-pascal-case*/}
          {/* <MRT_ToggleGlobalFilterButton table={table} /> */}
          <MRT_ToggleFiltersButton table={table} />
          <MRT_ShowHideColumnsButton table={table} />
          <MRT_ToggleFullScreenButton table={table} />
          {/* eslint-enablereact/jsx-pascal-case */}
          {inviteSurveyType !== constants.inviteSurveyType.comms && (
            <Tooltip title="Export Via Report" arrow>
              <IconButton
                onClick={() => {
                  setShowReportNameInput(
                    `${new Date().toJSON().slice(0, 10)}_${inviteSurveyType}_invites_`,
                  );
                }}
              >
                <FileDownloadIcon />
              </IconButton>
            </Tooltip>
          )}

          {showReportNameInput && (
            <TextInputDialog
              dialogTitle="Report Name"
              dialogMessage={"Please name your report"}
              inputLabel={`${"Report Name"}`}
              defaultValue={showReportNameInput}
              open={showReportNameInput}
              onAccept={theText => {
                /// do it!
                //create the report ..

                let theReport = createNewReport();
                theReport.omniData.name = theText;
                theReport.omniData.reportType = constants.reportTypeEnums.invites;

                theReport.omniData["onlyFields"] = getReportOnlyFields(
                  constants.reportTypeEnums.invites,
                );
                let theQuery = invitePagination.query;

                if (inviteSurveyType === constants.inviteSurveyType.shared) {
                  theQuery["omniData.inviteType"] = constants.inviteType.shared;

                  if (!theQuery.hasOwnProperty("omniData.target")) {
                    theQuery["omniData.target"] = {
                      "#regex": "^((?!default shar).)*$",
                      "#options": "i",
                    };
                  }
                }
                if (inviteSurveyType === constants.inviteSurveyType.auto) {
                  theQuery["omniData.inviteType"] = constants.inviteType.shared;

                  if (!theQuery.hasOwnProperty("omniData.target")) {
                    theQuery["omniData.target"] = { "#regex": "default shar", "#options": "i" };
                  }
                }
                if (inviteSurveyType === constants.inviteSurveyType.personal) {
                  theQuery["omniData.inviteType"] = constants.inviteType.single;
                }

                theReport.omniData["query"] = theQuery;
                delete theReport.omniData.dateBefore;
                delete theReport.omniData.dateAfter;

                props.createReportRequest(theReport);

                setShowReportNameInput(false);
              }}
              onClose={() => {
                setShowReportNameInput(false);
              }}
            />
          )}

          {showConfirm && (
            <AlertDialog
              open={showConfirm}
              dialogTitle={`Confirm`}
              dialogMessage={`Are you sure you want delete these ${invitePagination.totalItems} Invites?`}
              onAccept={() => {
                //do delete
                setDeleteAllPages(true);
                setShowConfirm(false);
              }}
              onClose={() => {
                setShowConfirm(false);
              }}
            />
          )}
        </Box>
      )}
      />
      </Box>
    </DatagridTooltipProvider>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  createReportRequest: AdminSessionActions.createReportRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(SurveyInvites);
